module.exports = __webpack_public_path__ + "static/media/hamburger.23fe34e2.svg";